// extracted by mini-css-extract-plugin
export var addButton = "ingredient-field-array-module--add-button--A9NfI";
export var container = "ingredient-field-array-module--container--SdoTF";
export var deleteButton = "ingredient-field-array-module--delete-button--cW2j1";
export var ingredientSelect = "ingredient-field-array-module--ingredient-select--SCDhu";
export var inputGroup = "ingredient-field-array-module--input-group--r4L+N";